/**
 * Where the fixed desktop sidebar sits — shared by `AppSidebar`,
 * `AdminSideNav` and `AppSidebarSkeleton` so the three cannot drift.
 *
 * - `z-nav`: sai-ui's nav layer (40), which emits CSS since #16990 loaded the
 *   rest of sai-ui's stylesheet (it was a literal `z-40` while it did not).
 *   Under the header stack (`z-nav-secondary`) and every overlay above it.
 * - `top-…!` (#15668): it starts BELOW the feedback banner and the session
 *   banners, which span the window (`use-app-banner-height.ts`).
 * - `h-auto!` (#16342): sai-ui's container is `fixed inset-y-0 h-svh`. With
 *   `top` and `bottom` both set and the height auto, the box always runs to
 *   the bottom of the current viewport. Never give it a viewport-unit height:
 *   `svh` is the viewport with Safari's toolbars EXPANDED, so on iPad/iOS
 *   Safari a `100svh` sidebar stopped short of the bottom once the toolbars
 *   collapsed on scroll, showing the body gradient in a strip below it.
 *
 * `!` beats sai-ui's own `top-0`/`h-svh` on the same element.
 *
 * Not shared by the legacy `AdminSidebar` (`src/components/admin-sidebar.tsx`),
 * whose `top` clears only the feedback banner. It carries the same `h-auto!`
 * rule, so change both together.
 */
export const SIDEBAR_FIXED_PLACEMENT_CLASS =
  'z-nav top-[calc(var(--feedback-banner-height,0px)+var(--app-banner-height,0px))]! h-auto!'
